
export function isNum(char: string) {
    return /\d/.test(char)
}

export function isStr(char: string) {
    return /[A-Za-z]/.test(char)
}
export function parseQueue(text: string): any[] {
    const first:any[] = []; 
    const second: any[] = [];
    const textArray: string[] = [];
    for(const c of text) {
        textArray.push(c);
    }

    textArray.forEach(e => {
      if (first.length === 0 && second.length === 0) {
        first.push(e);
      } else {
        const st = first.at(0);

        if (st && (isNum(e) === isNum(st) || isStr(e) === isStr(st)))
            first.push(e);
        else
            second.push(e)
      }
    })
    return [first.join(''), second.join('')].filter(e => e !== '');
}

const parseDozensNumber = (num: number, audioPath: any[]) => {
    const st = `${num}`.at(0);
    const nd = `${num}`.at(1);
    if (num < 20) {
        audioPath.push(`number${nd}`, `numberDozen`);
    } else {
        audioPath.push(`number${st}`, `numberDozens`);
        if ((num % 10) !== 0) {
            audioPath.push(`number${nd}`)
        }
    }
}

export const parseNumberToPath = (num: number, audioPath: any[]): void => {
    if (num) {
        if (num < 12) {
            audioPath.push(`number${num}`)
        } else if (num < 100) {
            parseDozensNumber(num, audioPath);
        } else if (num < 200) {
            audioPath.push(`number100`)
            if (num !== 100) {
                parseNumberToPath(Number(`${num}`.slice(1)), audioPath);
            }
        } else if (num >= 200) {
            const st = `${num}`.at(0);
            audioPath.push(`number${st}`, `numberHundred`);
            parseNumberToPath(Number(`${num}`.slice(1)), audioPath);
        }
    }
}


export async function playSoundByPath(path: string[], totalPath: number) {
    const indexNum = totalPath - 1;
    const ad = new Audio(path[indexNum])
    ad?.play();
    ad.addEventListener('ended', (e) => {
        if (indexNum > 0) {
            playSoundByPath(path, indexNum);
        }
    })
}

export const youtubeParser = (url: string): string | boolean => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11)? match[7] : false;
}
